'use strict'

require "signature-pad/jquery.signaturepad.js"

define ['./signatureBase.css'], () ->
  (RentappService, $state, $uibModal) ->
    restrict: "E"
    template: require("./signatureBase.jade")
    scope: { field: "=", mode: "@", stage: "="}
    link: (scope, element, attrs) ->
      scope.signType = 'draw'
      sig = scope.field.value
      
      if sig
        if sig[0] == "[" && sig[1] == "{"
          scope.signType = 'draw'
        else
          scope.signType = 'type'

      scope.openModal = () ->
        $uibModal.open
          scope: scope
          template: require("./signatureModal.jade")
          windowClass: 'signature-modal'
      scope.doType = () ->
        scope.signType = 'type'
        scope.field.value = ''

      scope.$on 'switch-draw', (event, data) ->
        if data.name == scope.field.name
          scope.signType = 'draw'



// WEBPACK FOOTER //
// ./directives/freeforms/signatureModal/signatureModal.coffee